import { render } from "./ProductQuantityAlert.vue?vue&type=template&id=46a88805"
import script from "./ProductQuantityAlert.vue?vue&type=script&lang=js"
export * from "./ProductQuantityAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__